import * as amplitude from '@amplitude/analytics-browser';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentUser } from 'store/user/selectors';

let isInitialized = false;

export const initAmplitude = () => {
    if (!isInitialized) {
        amplitude.init(import.meta.env.AMPLITUDE_API_KEY, {
            autocapture: {
                attribution: false,
                pageViews: false,
                sessions: false,
                formInteractions: false,
                fileDownloads: false,
                elementInteractions: false,
            },
        });
        isInitialized = true;
    }
};

export const useTrackAmplitudeEvent = () => {
    const { core_id } = useSelector(selectCurrentUser);
    const hasIdentified = useRef(false);

    useEffect(() => {
        if (!hasIdentified.current && core_id) {
            amplitude.setUserId(core_id.toString());

            hasIdentified.current = true;
        }
    }, [core_id]);

    return (eventName: string, eventProps: Record<string, any> = {}) => {
        if (isInitialized) {
            amplitude.track(eventName, eventProps);
        } else {
            console.warn(`Amplitude not initialized yet. Event "${eventName}" was not tracked.`);
        }
    };
};
